export default function getNearestProgram(programs, currentTime) {
  if (!programs) {
    return null;
  }

  const filteredPrograms = programs.filter(({ empty }) => !empty);
  const activeProgram = filteredPrograms.find(({ active }) => active);
  return activeProgram || sortPrograms(filteredPrograms, currentTime);
}

function sortPrograms(programs, currentTime) {
  const sortedPrograms = programs.sort((a, b) => {
    return Math.abs(currentTime - a.since) - Math.abs(currentTime - b.since);
  });
  return sortedPrograms[0];
}
